import React, { useCallback, useEffect, useMemo, useState } from "react";
import CTA from "../../assets/images/cta.jpg";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";

const buildMediaUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = (process.env.REACT_APP_API || "").replace(/\/+$/, "");
  if (!base) return path;
  const normalizedBase = base.replace(/\/v1$/i, "");
  return `${normalizedBase}/${path.replace(/^\/+/, "")}`;
};

const normalizeMomentData = (data) => {
  if (!data) return [];
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data)) return data;
  return [];
};

function CTASection() {
  const [moments, setMoments] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleMomentClick = (momentId) => {
    if (momentId && momentId !== "fallback") {
      // Open in new tab
      window.open(`/saudia-moments?momentId=${momentId}`, '_blank', 'noopener,noreferrer');
    }
  };

  const fetchMoments = useCallback(async () => {
    setLoading(true);
    try {
      const response = await handleApiCall("get", endpoints.saudiaMomentList);
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true
      ) {
        const normalized = normalizeMomentData(response?.data?.data || response?.data);
        setMoments(normalized);
      } else {
        setMoments([]);
      }
    } catch (error) {
      console.error("Error fetching Saudia moments:", error);
      setMoments([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMoments();
  }, [fetchMoments]);

  const momentImages = useMemo(() => {
  if (moments.length) {
    return moments
      .map((item, index) => ({
        id: item?._id || item?.id || index,
        desktopImage: buildMediaUrl(item?.desktop_image),
        mobileImage: buildMediaUrl(item?.mobile_image),
      }))
      .filter((img) => img.desktopImage || img.mobileImage);
  }
  return [{ id: "fallback", mobileImage: CTA }];
}, [moments]);

  return (
    <div className="cta text-center flex flex-col items-center justify-center gap-8 my-12 md:my-20 max-w-8xl mx-auto px-6 md:px-12 lg:px-28" id="saudia-moments">
      {momentImages.map((image) => (
        <picture key={image.id} className="w-full block">
          {image.desktopImage && (
            <source media="(min-width: 768px)" srcSet={image.desktopImage} />
          )}
          <img
            src={image.mobileImage || image.desktopImage}
            alt="Saudia moment"
            loading="lazy"
            onClick={() => handleMomentClick(image.id)}
            className={`w-full max-h-[600px] object-cover rounded-3xl shadow-2xl border border-white/10 ${
              image.id !== "fallback"
                ? "cursor-pointer hover:opacity-90 transition-opacity"
                : ""
            }`}
          />
        </picture>
      ))}
      {loading && !moments.length && (
        <p className="text-white/70 text-lg font-SaudiaLight mt-4">Loading...</p>
      )}
    </div>
  );
}

export default CTASection;
